'use client';

import { Button, type ButtonProps } from '@/app/components/ui/button';
import { reportEvent } from '@/app/utils';
import { useRouter } from '@/i18n/routing';

interface GenerateNowButtonProps extends ButtonProps {
  page: string;
  redirectUrl: string;
}

export function GenerateNowButton({ page, redirectUrl, children, ...props }: GenerateNowButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    reportEvent('element_click', {
      element_name: 'generate-now',
      page,
    });
    router.push(redirectUrl);
  };

  return (
    <Button size="lg" onClick={handleClick} {...props}>
      {children}
    </Button>
  );
}
